import EarMark from '../../components/ChatPriceCard/EarMark';
import { FirstSessionPromise, ListenerInviteBanner, ReferralCreditNote, TopSweetListeners, SweetGuaranteeBanner, SweetGuaranteeLine } from '../../components/GrowthPromos/GrowthPromos';
import React, { useEffect } from 'react';
import SweetTreatStrip from '../../components/SweetTreatStrip/SweetTreatStrip';
import { useHiddenListingIds, withoutHidden } from '../../util/hiddenListings';
import { bool, arrayOf, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';
import { createSlug } from '../../util/urlHelpers';
import { listingCardDisplayName, talkerBookingDisplayName } from '../../util/listingCardCopy';
import { HOMEPAGE_LISTENER_PAGE_SIZE } from '../../util/featured';
import useReviewStats from '../../util/useReviewStats';
import { rankHomeListenerCards } from '../../util/listingReviews';
import { listingCardPhotoUrl, listingHasRealFacePhoto, pickHomepageListenerCards } from '../../util/listingCardPhoto';
import { filterLandingFeaturedListings } from '../../util/landingSearch';
import { excludeOwnDiscoveryListings } from '../../util/ownDiscoveryListings';
import { isListingOnline } from '../../util/presence';
import {
  LISTENER_PRIMARY_CTA,
  LISTENER_STATUS,
  formatNextAvailableClock,
  listenerPrimaryCtaMessageId,
  listenerStatusMessageId,
  resolveListenerAvailability,
} from '../../util/listenerAvailability';
import { propTypes } from '../../util/types';
import { landingSchemaDescription, landingSchemaTitle } from '../../util/launchSeo';
import { abandonCheckoutDraft, listingBookingLinkProps } from '../../util/bookingIntent';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';

import { BrandLockup, NamedLink, NamedRedirect, Page } from '../../components';
import { EmergencyLine } from '../../components/EmergencyHelp/EmergencyHelp';
import usePresenceMap from '../../util/usePresenceMap';
import { formatNextSlotLabel } from '../../util/nextPlanSlot';
import useNextSlots from '../../util/useNextSlots';
import { TALK_THEMES } from '../../config/talkThemes';
import BestListeners from '../../components/BestListeners/BestListeners';
import {
  SITE_FOOTER_COPYRIGHT,
  SITE_FOOTER_LEGAL_LINKS,
  SITE_SOCIAL_LINKS,
} from '../../util/siteSocials';

import { destinationAfterVerifiedAccount, showBecomeAListenerCta } from '../../util/accountRole';
import { landingPageLinkTo, isPublicHomeView, redirectSearchWithPromo } from '../../util/publicHome';
import { SocialLinks } from '../FooterContainer/SiteFooter';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { HeartAvatarFace } from '../../components/HeartAvatar/HeartAvatar';


import { topicChips } from '../../components/CompactListenerCard/CompactListenerCard';
import InviteStrip from '../../components/InviteStrip/InviteStrip';
import { openHelpWidget } from '../../util/helpScoutBeacon';
import HomeTopicSearch from '../../components/HomeTopicSearch/HomeTopicSearch';
import homeCardListeners from '../../assets/home-cards/path-listeners.jpg';
import homeCardSkillz from '../../assets/home-cards/path-skillz.jpg';
import homeCardEarnListen from '../../assets/home-cards/earner-listener.jpg';
import homeCardEarnTeach from '../../assets/home-cards/earner-teach.jpg';
import HowItWorksSteps from '../../components/HowItWorksSteps/HowItWorksSteps';
import HelloPlayBadge from '../../components/HelloVideo/HelloPlayBadge';
import { StartingAtLine } from '../../components/ListenerPriceTiles/ListenerPriceTiles';
import homeDPhoto from '../../assets/landing/home-d-baking-lesson.jpg';
import homeDTalkPhoto from '../../assets/landing/home-d-texting-couch.jpg';
import ThumbCtas from '../../components/ThumbCtas/ThumbCtas';
import css from './LandingPage.module.css';
import { useShowFreeCtas } from '../../components/FirstSessionFree/FirstSessionFree';
import nh from '../NewAudiencePage/NewHome.module.css';

import heroStillLife from '../../assets/landing/hero-still-life.jpg';
import {
  IconBook,
  IconDollar,
  IconPeople,
  IconSpeech,
} from './LandingIcons';

const listingImageUrl = listingCardPhotoUrl;


/** Home talker card "Popular topics" chips (Sam mock, Oct 16): real taxonomy paths. */
const cardTopicHref = path => (path ? `/s?mode=topics&paths=${encodeURIComponent(path)}` : '/s?mode=topics');
const CARD_TOPIC_CHIPS = [
  ['Sports', 'sports', 'ball'],
  ['Pets', 'hobbies/pets', 'paw'],
  ['Travel', 'hobbies/travel', 'plane'],
  ['Relationships', 'life/relationships-dating', 'heart'],
  ['Food', 'hobbies/cooking-food', 'cup'],
  ['+ More', null, null],
];
const LP = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
const CHIP_ICONS = {
  ball: <svg {...LP}><ellipse cx="12" cy="12" rx="10" ry="6" transform="rotate(-45 12 12)" /><path d="m9 15 6-6M10.5 10.5l3 3" /></svg>,
  paw: <svg {...LP}><circle cx="5" cy="11" r="2" /><circle cx="9" cy="6" r="2" /><circle cx="15" cy="6" r="2" /><circle cx="19" cy="11" r="2" /><path d="M12 12c-3 0-6 4-6 6.5S8 21 12 19.5c4 1.5 6 0 6-1S15 12 12 12Z" /></svg>,
  plane: <svg {...LP}><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" /></svg>,
  heart: <svg {...LP}><path d="M19 14c1.5-1.5 3-3.2 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.8 0-3 .5-4.5 2-1.5-1.5-2.7-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7Z" /></svg>,
  cup: <svg {...LP}><path d="M17 8h1a4 4 0 1 1 0 8h-1" /><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" /><path d="M6 2v2M10 2v2M14 2v2" /></svg>,
};
const IconLockLine = () => (
  <svg {...LP}><path d="M6 11h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2Z" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /><path d="M12 15v2" /></svg>
);
const IconCalendarLine = () => (
  <svg {...LP}><path d="M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
);

const Benefit = ({ icon, title, text, tone }) => (
  <div className={css.benefit}>
    <div className={tone === 'blue' ? css.benefitIconBlue : css.benefitIconPink}>{icon}</div>
    <div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  </div>
);

// Live home "Join as a talker" block, reused on /for-talkers (Sam, Oct 20 2026). Sans headings per site font rule.
export const TalkerJoinSection = ({ cta, chips = true }) => (
  <div className={css.joinSans} data-talker-join="true">
    <p className={css.joinKicker}>Join as a talker</p>
    <Benefit tone="pink" icon={<IconSpeech />} title="Explore topics you love" text="From sports and hobbies to relationships, travel, work, and everyday life." />
    <Benefit tone="pink" icon={<IconPeople />} title="Connect with someone who shares your interests" text="Browse friendly listeners with life experience and similar interests." />
    <Benefit tone="pink" icon={<IconLockLine />} title="Talk privately, without judgment" text="Enjoy a one-on-one conversation where you can be yourself." />
    {chips ? (
      <>
    <p className={css.popularLabel}>Popular topics</p>
    <ul className={css.popularChips} data-home-popular-chips="true">
      {CARD_TOPIC_CHIPS.map(([label, path, icon]) => (
        <li key={label}>
          <a className={css.popularChip} href={cardTopicHref(path)} data-home-card-chip={path || 'more'}>
            {icon ? <span className={css.popularChipIcon} aria-hidden="true">{CHIP_ICONS[icon]}</span> : null}
            {label}
          </a>
        </li>
      ))}
    </ul>
      </>
    ) : null}
    {cta !== undefined ? cta : (
      <NamedLink name="SearchPage" to={{ search: '?mode=listeners' }} className={css.pinkCTA}>
        Explore Topics &amp; Listeners →
      </NamedLink>
    )}
  </div>
);
export const talkerJoinCtaClass = css.pinkCTA;

const TALKER_BROWSE_TOPICS = [
  ['Just talk', 'just-talk'],
  ['Relationships & life', 'life'],
  ['Career & money', 'work'],
  ['Sports & games', 'sports'],
  ['Shows & entertainment', 'shows'],
  ['Hobbies & everyday', 'hobbies'],
  ['World & tech', 'world'],
  ['Health', 'health'],
  ['Relocation / New in town', 'new-in-town'],
  ['Life guidance', 'mentorship-life-guidance'],
  ['+ More', null],
];
export const TalkerBrowseTopics = () => (
  <div className={css.joinSans} data-talker-topics="true">
    <p className={css.joinKicker}>Browse by topic</p>
    <ul className={css.popularChips} data-home-popular-chips="true">
      {TALKER_BROWSE_TOPICS.map(([label, path]) => (
        <li key={label}>
          <a className={css.popularChip} href={cardTopicHref(path)} data-talker-topic={path || 'more'}>{label}</a>
        </li>
      ))}
    </ul>
  </div>
);

// Same compact listener cards as the Live home, Available Now first.
export const TalkerListenerCards = ({ listings = [] }) => {
  const ids = listings.map(l => l?.id?.uuid).filter(Boolean);
  const { map: presenceMap, pausedMap = {}, busyMap = {}, nextAvailableMap = {} } = usePresenceMap(ids);
  const isAvail = listing =>
    resolveListenerAvailability({
      listing,
      online: isListingOnline(listing.id.uuid, presenceMap, listing),
      sessionBusy: !!busyMap[listing.id.uuid],
      startNowPaused: !!pausedMap[listing.id.uuid],
    }).status === LISTENER_STATUS.AVAILABLE;
  const statsMap = useReviewStats(ids);
  const picked = rankHomeListenerCards(
    pickHomepageListenerCards(filterLandingFeaturedListings(listings, { presenceMap }), Number.MAX_SAFE_INTEGER).filter(listingHasRealFacePhoto),
    { isAvailable: isAvail, statsMap }
  ).slice(0, HOMEPAGE_LISTENER_PAGE_SIZE);
  const nextSlots = useNextSlots(picked.map(l => l.id.uuid));
  const shown = picked.slice(0, 8);
  if (!shown.length) return null;
  return (
    <div className={css.joinSans} data-talker-listeners="true">
      <p className={css.joinKicker}>Meet some Sweet Listeners</p>
      <div className={classNames(css.listenerRow, css.listenerRowCompact)} data-compact-row="true">
        {shown.map(listing => (
          <Listener
            key={listing.id.uuid}
            listing={listing}
            online={isListingOnline(listing.id.uuid, presenceMap, listing)}
            sessionBusy={!!busyMap[listing.id.uuid]}
            startNowPaused={!!pausedMap[listing.id.uuid]}
            nextAvailableAt={nextAvailableMap[listing.id.uuid] || null}
            nextSlotAt={nextSlots[listing.id.uuid] || null}
          />
        ))}
      </div>
      <NamedLink name="SearchPage" to={{ search: '?mode=listeners' }} className={css.seeAllLink}>See all listeners →</NamedLink>
    </div>
  );
};

/**
 * Compact Featured card from the homepage spec. Photo / View profile open
 * the profile. Book / Start go straight to the booking page (guests Sign up).
 *
 * @param {Object} props
 * @param {Object} props.listing
 * @param {boolean} props.online
 * @returns {JSX.Element}
 */
const bookingModeForCta = primaryCta => {
  if (primaryCta === LISTENER_PRIMARY_CTA.TALK_NOW) {
    return 'now';
  }
  if (primaryCta === LISTENER_PRIMARY_CTA.BOOK_NEXT) {
    return 'next';
  }
  return 'later';
};

const Listener = props => {
  const {
    listing,
    online,
    sessionBusy = false,
    startNowPaused = false,
    nextAvailableAt = null,
    nextSlotAt = null,
    rich = false,
  } = props;
  const title = listing.attributes?.title || '';
  const bio = rich ? String(listing.attributes?.description || '').replace(/\s+/g, ' ').trim() : '';
  const bioLine = bio.length > 80 ? bio.slice(0, 78).replace(/\s\S*$/, '') + '…' : bio;
  const slug = createSlug(title);
  const name = listingCardDisplayName(listing);
  const image = listingImageUrl(listing);
  const availability = resolveListenerAvailability({
    listing,
    online,
    sessionBusy,
    startNowPaused,
    nextAvailableAt,
  });
  const statusClass =
    availability.status === LISTENER_STATUS.AVAILABLE
      ? css.onlineOn
      : availability.status === LISTENER_STATUS.IN_CONVERSATION
      ? css.statusBusy
      : css.statusOffline;
  const primaryClass =
    availability.primaryCta === LISTENER_PRIMARY_CTA.TALK_NOW
      ? classNames(css.book, css.talkNow)
      : css.book;
  const offlineNextLabel =
    availability.status === LISTENER_STATUS.OFFLINE
      ? formatNextSlotLabel(nextSlotAt)
      : null;
  const clockLabel = formatNextAvailableClock(
    availability.nextAvailableAt,
    listing?.attributes?.availabilityPlan?.timezone
  );

  return (
    <article
      className={css.listener}
      data-featured-card="true"
      data-availability={availability.status}
    >
      <NamedLink
        name="ListingPage"
        params={{ id: listing.id.uuid, slug }}
        className={css.listenerPhotoOuter}
        data-featured-photo-link="true"
        ariaLabel={name || title}
      >
      {image ? (
        <img src={image} alt={name || title} loading="lazy" decoding="async" />
      ) : (
        <div
          className={css.listenerPhotoFallback}
          aria-hidden="true"
          data-featured-heart="true"
        >
          <HeartAvatarFace user={listing?.author} listener square />
        </div>
      )}
      <HelloPlayBadge userId={listing?.author?.id?.uuid} name={name} size="lg" />
      </NamedLink>
      <div className={css.listenerInfo}>
        {rich ? (
          <NamedLink name="ListingPage" params={{ id: listing.id.uuid, slug }} className={css.nhCardName} data-home-strip-name="true"><strong>{name}</strong></NamedLink>
        ) : (
          <strong>{name}</strong>
        )}
        {rich ? <StartingAtLine publicData={listing.attributes?.publicData} small /> : null}
        {bioLine ? <p className={css.nhBio}>{bioLine}</p> : null}
        <div className={css.listenerMeta}>
          <small className={statusClass}>
            {offlineNextLabel ? (
              <span data-featured-next="true">
                <FormattedMessage
                  id="AvailableNowBadge.offlineNext"
                  values={{ time: offlineNextLabel }}
                />
              </span>
            ) : (
              <FormattedMessage
                id={listenerStatusMessageId(availability.status, clockLabel)}
                values={{ time: clockLabel }}
              />
            )}
          </small>
        </div>
        {topicChips(listing).length ? (
          <div className={css.compactChips} data-compact-chips="true">
            {topicChips(listing).map(c => (
              <span key={c}>{c}</span>
            ))}
          </div>
        ) : null}
        <NamedLink
          className={css.viewProfile}
          name="ListingPage"
          params={{ id: listing.id.uuid, slug }}
          data-featured-profile="true"
          data-card-view-profile="true"
        >
          View profile →
        </NamedLink>
        <ThumbCtas listing={listing} availability={availability} />
      </div>
    </article>
  );
};

const WHY_LISTEN = [
  'Get paid for something you’re already good at.',
  'Earn from home, on your own schedule.',
  'Make someone’s day a little better.',
  'Meet interesting people from everywhere.',
  'Turn free time into extra income.',
  'Feel good knowing you helped.',
];
const WHY_TALK = [
  'Feel lighter after getting it off your chest.',
  'Finally be heard, without judgment.',
  'Someone in your corner, whenever you need it.',
  'Vent, celebrate, think out loud, or just chat.',
  'Share good news with someone who cares.',
  'Get an outside view on a decision.',
  'Their full attention is on you, with no waiting your turn.',
  'No favors owed. No awkwardness later.',
  'Private, with someone outside your circle.',
  'There when you need them, even when friends aren’t around.',
  'Less than lunch, and your first chat is free.',
];
const HOME_BENEFITS = [
  'Talk it out with a listener, or learn a skill one-on-one.',
  'Text, voice or video, whatever feels easiest.',
  'Each teacher sets their own price. Sessions from $5.',
  'Your first 15 minutes are free.',
  'Book instantly. No waiting for approval.',
  'One account to talk, listen, learn and teach.',
  'Pay by card or Apple Pay.',
];
const HOME_BRAND_LINE = 'That’s Sweet Listeners.';
// Heart sparkles (Sam OK Oct 20): decorative, lingers ~4.8s per line, around (not on) the words.

// Sam, Oct 21: half as many sparkles.
const SPARKS = Array.from({ length: 8 }, (_, k) => {
  const r = n => { const x = Math.sin((k + 1) * 9301 + n * 49297) * 233280; return x - Math.floor(x); };
  // Oct 21: top/bottom bands only, outside the text box, drifting outward, so letters stay readable.
  const side = (k >> 1) % 2;
  const left = 4 + r(1) * 92;
  const top = side ? 104 + r(2) * 8 : -14 - r(2) * 8;
  const dx = (r(3) - 0.5) * 18; const dy = (side ? 1 : -1) * (6 + r(4) * 10);
  return { c: k % 2 ? '#0B7FD1' : '#E8457A', blue: k % 2 === 1, left, top, dx, dy, size: 13 + r(5) * 7, delay: r(6) * 0.5 };
});
const HeartSparkles = () => (
  <span className={nh.fx} aria-hidden="true">
    {SPARKS.map((q, k) => (
      <i
        key={k}
        data-spark={q.blue ? 'blue' : 'pink'}
        style={{ left: `${q.left}%`, top: `${q.top}%`, color: q.c, animationDelay: `${q.delay}s`, '--dx': `${q.dx}px`, '--dy': `${q.dy}px` }}
      >
        <EarMark size={q.size} />
      </i>
    ))}
  </span>
);
// Fade 1.0s in, 3.5s hold, 1.0s out. Reduced motion: static brand line.
const BenefitLoop = () => {
  const showFreeLines = useShowFreeCtas();
  const lines = [...HOME_BENEFITS.filter(l => showFreeLines || !/free/i.test(l)), HOME_BRAND_LINE];
  const [i, setI] = React.useState(0);
  const [show, setShow] = React.useState(true);
  const [still, setStill] = React.useState(false);
  useEffect(() => {
    const rm = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rm) { setStill(true); return undefined; }
    let t1; let t2;
    const cycle = () => {
      t1 = setTimeout(() => {
        setShow(false);
        t2 = setTimeout(() => { setI(n => (n + 1) % lines.length); setShow(true); cycle(); }, 1000);
      }, 4500);
    };
    cycle();
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);
  const line = still ? HOME_BRAND_LINE : lines[i];
  return (
    <div className={nh.stage} data-home-benefit-stage="true">
      <p
        className={line === HOME_BRAND_LINE ? nh.stageBrand : nh.stageLine}
        style={{ opacity: show || still ? 1 : 0 }}
        data-home-benefit={i}
      >
        {line}
      </p>
      {still ? null : <HeartSparkles key={i} />}
    </div>
  );
};

// Home A/B (Sam, Oct 22 2026 4:59 PM, TEST): 50/50 sticky cookie sl_home_v, ?home=a|b override.
// SSR renders A; the client picks the variant after mount. GA4: home_variant, home_card_click.
const gaEvent = (name, params) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag('event', name, params);
  } catch (e) {
    /* ignore */
  }
};
const trackHomeCard = (variant, card) => gaEvent('home_card_click', { variant, card });
// Home variants (Sam, Oct 23 2026): ?home=a|b|c preview; default A. GA4: home_variant, home_card_click.
const useHomeVariant = search => {
  const q = ((/[?&]home=([abcd])\b/i.exec(search || '') || [])[1] || 'd').toLowerCase();
  useEffect(() => {
    gaEvent('home_variant', { variant: q });
  }, [q]);
  return q;
};

const HomePathIcon = ({ kind }) => {
  const p = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (kind === 'chat') return <svg viewBox="0 0 24 24" width="36" height="36"><path {...p} d="M12 3.5c4.7 0 8.5 3.3 8.5 7.4s-3.8 7.4-8.5 7.4c-1 0-2-.1-2.9-.4L4.5 20l1.3-3.6C4.4 15 3.5 13 3.5 10.9 3.5 6.8 7.3 3.5 12 3.5z" /></svg>;
  if (kind === 'headphones') return <svg viewBox="0 0 24 24" width="36" height="36"><path {...p} d="M4 15v-3a8 8 0 0116 0v3" /><rect x="3" y="14" width="4.5" height="6.5" rx="1.6" fill="currentColor" /><rect x="16.5" y="14" width="4.5" height="6.5" rx="1.6" fill="currentColor" /></svg>;
  if (kind === 'cap') return <svg viewBox="0 0 24 24" width="38" height="38"><path {...p} d="M2.5 9L12 4.5 21.5 9 12 13.5z" /><path {...p} d="M6.5 11v4.5c0 1.6 2.5 3 5.5 3s5.5-1.4 5.5-3V11" /><path {...p} d="M21.5 9v5" /></svg>;
  return <svg viewBox="0 0 24 24" width="38" height="38" fill="currentColor"><circle cx="12" cy="7.5" r="3.2" /><circle cx="5.5" cy="9" r="2.4" /><circle cx="18.5" cy="9" r="2.4" /><path d="M6.5 20c0-3.4 2.5-6 5.5-6s5.5 2.6 5.5 6z" /><path d="M1.5 19.5c0-2.6 1.8-4.5 4-4.5.8 0 1.5.2 2.1.6-1 1.1-1.6 2.5-1.8 3.9z" /><path d="M22.5 19.5c0-2.6-1.8-4.5-4-4.5-.8 0-1.5.2-2.1.6 1 1.1 1.6 2.5 1.8 3.9z" /></svg>;
};


const DIcon = ({ k, size = 22 }) => {
  const p = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round' };
  const d = {
    chat: <path {...p} d="M12 4c4.4 0 8 3 8 6.8s-3.6 6.8-8 6.8c-.9 0-1.8-.1-2.6-.4L5 19l1.1-3.2C4.8 14.6 4 12.8 4 10.8 4 7 7.6 4 12 4z" />,
    chats: <><path {...p} d="M9 5c3.6 0 6.5 2.4 6.5 5.4S12.6 15.8 9 15.8c-.7 0-1.4-.1-2-.3L4 17l.9-2.4C3.7 13.6 3 12.1 3 10.4 3 7.4 5.4 5 9 5z" /><path {...p} d="M17.6 9.2c2 .8 3.4 2.5 3.4 4.4 0 1.3-.6 2.5-1.6 3.3L20 19l-2.6-1c-.7.2-1.4.3-2.1.3-1.6 0-3.1-.5-4.2-1.4" /></>,
    book: <><path {...p} d="M3 5.5c2.5-1 5.5-1 9 1 3.5-2 6.5-2 9-1v13c-2.5-1-5.5-1-9 1-3.5-2-6.5-2-9-1z" /><path {...p} d="M12 6.5v13" /></>,
    bookpen: <><path {...p} d="M3 6c2.3-.9 5-.9 8 .8V19c-3-1.7-5.7-1.7-8-.8z" /><path {...p} d="M11 6.8c2-1.1 3.8-1.5 5.4-1.3" /><path {...p} d="M14 18.5l6.2-6.2 1.5 1.5-6.2 6.2-2 .5z" /></>,
    gift: <><rect {...p} x="4" y="9" width="16" height="11" rx="1.5" /><path {...p} d="M3 9h18M12 9v11M12 9c-1.5-3-5-3.5-5-1.3S10 9 12 9zm0 0c1.5-3 5-3.5 5-1.3S14 9 12 9z" /></>,
    headphones: <><path {...p} d="M4 15v-3a8 8 0 0116 0v3" /><rect {...p} x="3" y="14" width="4" height="6" rx="1.5" /><rect {...p} x="17" y="14" width="4" height="6" rx="1.5" /><path {...p} d="M12 17.5l-1.2-1.1a1 1 0 011.2-1.5 1 1 0 011.2 1.5z" /></>,
    people: <><circle {...p} cx="9" cy="8" r="3" /><path {...p} d="M3.5 19c0-3.2 2.5-5.5 5.5-5.5s5.5 2.3 5.5 5.5" /><circle {...p} cx="16.5" cy="9" r="2.4" /><path {...p} d="M16 13.6c2.6.2 4.5 2.3 4.5 5" /></>,
    teach: <><circle {...p} cx="9" cy="8" r="3" /><path {...p} d="M3.5 19c0-3.2 2.5-5.5 5.5-5.5 1.5 0 2.8.5 3.8 1.4" /><path {...p} d="M18 13v6M15 16h6M19 5l.6 1.4L21 7l-1.4.6L19 9l-.6-1.4L17 7l1.4-.6z" /></>,
    shield: <><path {...p} d="M12 3l7 3v5.5c0 4.4-3 7.9-7 9.5-4-1.6-7-5.1-7-9.5V6z" /><rect {...p} x="9" y="11" width="6" height="4.5" rx="1" /><path {...p} d="M10.3 11V9.6a1.7 1.7 0 013.4 0V11" /></>,
    shieldcheck: <><path {...p} d="M12 3l7 3v5.5c0 4.4-3 7.9-7 9.5-4-1.6-7-5.1-7-9.5V6z" /><path {...p} d="M8.8 12l2.2 2.2 4.2-4.4" /></>,
    leaf: <><path {...p} d="M5 19c0-8 5-13 14-14 0 9-5 14-13 14" /><path {...p} d="M5 19l7-7" /></>,
    lock: <><rect {...p} x="5" y="10.5" width="14" height="10" rx="2" /><path {...p} d="M8 10.5V8a4 4 0 018 0v2.5M12 14.5v2.5" /></>,
    id: <><rect {...p} x="3" y="5" width="18" height="14" rx="2" /><circle {...p} cx="9" cy="11" r="2.2" /><path {...p} d="M5.8 16.2c.6-1.6 1.8-2.4 3.2-2.4s2.6.8 3.2 2.4M14.5 10h4M14.5 13.5h3" /></>,
    cal: <><rect {...p} x="3.5" y="5" width="17" height="15" rx="2" /><path {...p} d="M3.5 9.5h17M8 3v4M16 3v4M7.5 13h2M11 13h2M14.5 13h2M7.5 16.5h2M11 16.5h2" /></>,
    heart: <path {...p} d="M12 20s-7.5-4.6-7.5-10A4.2 4.2 0 0112 7.6 4.2 4.2 0 0119.5 10c0 5.4-7.5 10-7.5 10z" />,
  };
  return <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">{d[k]}</svg>;
};

// Sam 2:18 Oct 23: remember returning visitors so signed-out they see Log in first.
const RETURNING_KEY = 'sl_returning';
export const isReturningVisitor = () => {
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem(RETURNING_KEY) === '1';
  } catch (e) {
    return false;
  }
};
export const markReturningVisitor = () => {
  try {
    window.localStorage.setItem(RETURNING_KEY, '1');
  } catch (e) {
    // private mode
  }
};

// Sam 3:11 Oct 23: hero photo A/B (baking | texting), sticky per visitor via cookie,
// forced with ?hero=baking|texting, reported to GA4 as hero_variant.
const HERO_COOKIE = 'sl_hero';
const HERO_VARIANTS = ['baking', 'texting'];
const useStickyVariant = (cookie, param, variants, gaKey) => {
  const [v, setV] = React.useState(variants[0]);
  React.useEffect(() => {
    let pick = variants[0];
    try {
      const forced = new URLSearchParams(window.location.search).get(param);
      const m = new RegExp(`(?:^|; )${cookie}=([a-z_]+)`).exec(document.cookie || '');
      pick = variants.includes(forced) ? forced : m && variants.includes(m[1]) ? m[1] : variants[Math.random() < 0.5 ? 0 : 1];
      document.cookie = `${cookie}=${pick}; path=/; max-age=${60 * 60 * 24 * 180}; SameSite=Lax`;
    } catch (e) {
      // keep default
    }
    setV(pick);
    try {
      if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', { [gaKey]: pick });
      gaEvent(`${gaKey}_view`, { [gaKey]: pick });
    } catch (e) {
      // analytics optional
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return v;
};
const useBenefitsVariant = () => useStickyVariant('sl_benefits', 'benefits', ['why_use', 'love_it'], 'benefits_variant');
const useHeadlineVariant = () => useStickyVariant('sl_headline', 'headline', ['people', 'classic'], 'headline_variant');
const useHeroVariant = () => {
  const [v, setV] = React.useState('baking');
  React.useEffect(() => {
    let pick = null;
    try {
      const forced = new URLSearchParams(window.location.search).get('hero');
      const m = /(?:^|; )sl_hero=(baking|texting)/.exec(document.cookie || '');
      pick = HERO_VARIANTS.includes(forced) ? forced : m ? m[1] : Math.random() < 0.5 ? 'baking' : 'texting';
      document.cookie = `${HERO_COOKIE}=${pick}; path=/; max-age=${60 * 60 * 24 * 180}; SameSite=Lax`;
    } catch (e) {
      pick = 'baking';
    }
    setV(pick);
    try {
      if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', { hero_variant: pick });
      gaEvent('hero_variant_view', { hero_variant: pick });
    } catch (e) {
      // analytics optional
    }
  }, []);
  return v;
};

// Sam Oct 27: paid Meta traffic gets a buyer-first home (no earner pitch above the fold).
export const isPaidBuyerSearch = (search = '') => {
  try {
    const q = new URLSearchParams(search || '');
    const med = (q.get('utm_medium') || '').toLowerCase();
    const src = (q.get('utm_source') || '').toLowerCase();
    const camp = (q.get('utm_campaign') || '').toLowerCase();
    return q.get('buyer') === '1' || med === 'paid' || med === 'cpc' || med === 'paid_social' ||
      ['facebook', 'fb', 'ig', 'instagram', 'an', 'meta'].includes(src) || camp.includes('talker');
  } catch (e) { return false; }
};
const usePaidBuyer = search => {
  const fromUrl = isPaidBuyerSearch(search);
  const [on, setOn] = React.useState(fromUrl);
  React.useEffect(() => {
    try {
      if (fromUrl) { window.sessionStorage.setItem('sl_buyer_mode', '1'); setOn(true); }
      else if (window.sessionStorage.getItem('sl_buyer_mode') === '1') setOn(true);
    } catch (e) {}
  }, [fromUrl]);
  return on;
};

const HomeD = ({ onCard, authed = false, returning = false, buyer = false, theme = null }) => {
  // Sam 2:49 Oct 23: hide the free link once a signed-in talker has used it.
  const showFreeNow = useShowFreeCtas();
  const hero = useHeroVariant();
  const headline = useHeadlineVariant(); // Sam Oct 28 10:15: A/B people-first header vs pre-Oct-28 classic (cookie sl_headline)
  const benefits = 'why_use'; // Sam 1:55 AM: always show 'Why use us' (was A/B with love_it)
  return (
  <main className={css.hdMain} data-home-hero="new" data-home-variant="d" data-home-mode={buyer ? 'buyer' : 'default'}>
    {/* Sam Nov 3 1:17 PM: "Remove banner" — free promo now lives in the hero. */}
    <section className={css.hdHeroBand}>
      <div className={css.hdHero} data-home-hero-layout="d">
        <div className={css.hdHeroText}>
          {theme ? (
            <>
            <span className={css.hdKicker} data-theme-kicker="true">{theme.kicker}</span>
            <h1 className={css.hdTitle} data-headline-variant="theme">{theme.h1}</h1>
            <p className={css.hdSub}>{theme.sub}</p>
            <p className={css.hdSub} data-theme-not-therapy="true">Real people, Online now. Not therapy.</p>
            </>
          ) : headline === 'classic' ? (
            <>
            <span className={css.hdKicker}>Text · Voice · Video</span>
            <h1 className={css.hdTitle} data-headline-variant="classic">Talk it out. <span className={css.hdTitlePink}>Learn a skill. In minutes.</span></h1>
            <p className={css.hdSub} data-classic-sub="true">Private one-on-one sessions with a friendly 18+ listener or a Sweet Skillz mentor. Your first 15 minutes are free. Start now, or book a time that fits.</p>
            </>
          ) : (
            <>
            <h1 className={css.hdTitle} data-headline-variant="people">What's on Your Mind Today?</h1>
            <p className={css.hdMindPink} data-home-explore="true">Explore Topics, Skills &amp; People</p>
            <p className={css.hdSub}>Find real people to talk with, or learn a new skill from, about the things that interest you.</p>
            </>
          )}
          {!authed ? (
            <>
            {showFreeNow ? (
              <div data-home-free-fold="true" style={{ marginTop: 16, padding: '22px 24px', border: 'none', borderRadius: 10, background: 'transparent', boxShadow: 'none', maxWidth: 520, textAlign: 'center' }} data-free-pill="true">
                <h2 style={{ fontSize: 20, fontWeight: 700, margin: '2px 0 6px' }}>Book your free session</h2>
                <p className={css.hdSub} style={{ margin: '0 0 12px' }}>Your first 15 minutes are free. Pick someone who's online right now and start talking.</p>
                <div className={css.hdBtns} data-hero-cta="true" style={{ justifyContent: 'center' }}>
                  <NamedLink name="SearchPage" to={{ search: theme ? `?promoFirstFree=1&availableNow=only&topics=${theme.topics.join(',')}` : '?promoFirstFree=1&availableNow=only' }} className={`${css.hdPrimary} ${css.hdPathPrimary}`} style={{ background: '#2563eb', borderColor: '#2563eb', color: '#fff' }} data-free-blue="true" data-home-cta="hero-primary" onClick={() => onCard('hero-primary')}>Start free now</NamedLink>
                </div>
                <p className={css.hdSub} style={{ fontSize: 14, marginTop: 8 }}>Before the session, we'll confirm your email and cell so we can let you know when your listener joins.</p>
              </div>
            ) : (
            <div className={css.hdBtns} data-hero-cta="true">
                <NamedLink name="SearchPage" to={showFreeNow ? { search: '?promoFirstFree=1&availableNow=only' } : { search: theme ? `?availableNow=only&treat=1&topics=${theme.topics.join(',')}` : '?availableNow=only&treat=1' }} className={`${css.hdPrimary} ${css.hdPathPrimary}`} data-home-cta="hero-primary" onClick={() => onCard('hero-primary')}>{showFreeNow ? 'Start free now' : 'Talk to someone now'}</NamedLink>
                <NamedLink name="SearchPage" to={showFreeNow ? { search: '?promoFirstFree=1' } : (theme ? { search: `?topics=${theme.topics.join(',')}` } : undefined)} className={css.hdSecondary} data-home-cta="hero-book" onClick={() => onCard('hero-book')}>{showFreeNow ? 'Book free later' : 'Book a time'}</NamedLink>
              </div>
            )}
            </>
          ) : null}
          {theme ? <SweetGuaranteeLine variant="talk-hero" /> : null}
          {authed ? (
            <div className={css.hdBtns}>
              <NamedLink name="DashboardPage" className={`${css.hdSecondary} ${css.hdDashBlue}`} data-home-cta="dashboard" onClick={() => onCard('dashboard')}>Go to my dashboard</NamedLink>
            </div>
          ) : null}
        </div>
      </div>
    </section>
    {theme ? null : <SweetGuaranteeBanner variant="home" />}
    <BestListeners title={theme ? theme.peopleTitle : "Find your person"} trustLine count={theme ? 12 : 10} topics={theme ? theme.topics : null} chipPrefer={theme ? theme.chipPrefer || null : null} />
    <div className={css.hdFindMore} data-home-find-more="true">
      <NamedLink name="SearchPage" className={css.hdFindMoreBtn} onClick={() => onCard('find-more')}>Find more people →</NamedLink>
    </div>
    <section className={css.hdReviews} data-home-reviews="true">
      <h2 className={css.hdH2}>What our community says</h2>
      <div className={css.hdReviewList}>
        {[
          ['6ad90774-5e67-4617-8ef3-e1a8a0fceffc', 5, 'She was great very nice to talk to', 'Falcon', 'Mommabear'],
          ['6ad880eb-c2ab-40a0-946a-faa0c2d03f06', 5, 'Very informative, attentive and makes me feel comfortable, confident and happy. Definitely plan on coming back!', 'BuckShotBow65', 'Insight_Echo'],
          ['6ae4e5eb-10d7-4df7-b03d-137078713f95', 5, 'Chrissy was so helpful even during our first session. She was very supportive and helpful. I would highly recommend Chrissy to anyone looking for a coach!', 'Rolls2', 'Chrissy'],
        ].map(([id, stars, text, who, listener]) => (
          <figure key={id} className={css.hdReview} data-review-id={id}>
            <div className={css.hdStars} role="img" aria-label={`${stars} out of 5 stars`}>{'★'.repeat(stars)}{'☆'.repeat(5 - stars)}</div>
            <blockquote className={css.hdReviewText}>“{text}”</blockquote>
            <figcaption className={css.hdReviewBy}><b>{who}</b> on a session with <b>{listener}</b></figcaption>
          </figure>
        ))}
      </div>
      <p className={css.hdPayStranger} data-home-pay-stranger="true">No history, no judgment, no one trying to fix your life — just someone who’s been there. {theme || showFreeNow ? 'For 15 minutes, all of their attention is on you.' : 'Paying is what makes it real: they show up for you, and you get their uninterrupted time.'}</p>
    </section>
    {benefits === 'why_use' ? (
    <section className={css.hdBenefitsBand} data-home-trust="true" data-benefits-variant="why_use">
      <h2 className={css.hdH2Light}>{theme ? 'Why talk it out here' : 'Why use us'}</h2>
      <div className={classNames(css.hdBenefits, css.hdBenefits3)}>
        {(theme ? [...theme.why.map(([k, t, h, l], i) => [k, t, h, l, i < 2]), showFreeNow ? ['gift', 'pink', 'Try it for free', 'Your first 15 minutes are free. Just confirm you’re 18+.'] : null] : [
          ['people', 'pink', 'All their attention is on you', 'No groups and no audience. It’s just you and one person, by text, voice or video.', true],
          ['chats', 'pink', 'Feel heard', 'Say what’s on your mind to someone who’s really listening.', true],
          ['teach', 'blue', 'Get better at something', 'Learn a skill one on one with Sweet Skillz, at your pace, from someone who loves teaching it.', true],
          ['shieldcheck', 'blue', 'Feel safe opening up', 'Every listener is a verified adult, and your contact details stay private.'],
          showFreeNow ? ['gift', 'pink', 'Try it for free', 'Your first 15 minutes are free. Just confirm you’re 18+.'] : null,
          ['chat', 'blue', 'Help when you need it', 'Talk right now, or book a time that fits your day.'],
          ['cal', 'pink', 'Only pay for what you use', 'No subscription and no commitment.'],
          buyer ? null : ['headphones', 'pink', 'Get paid for what you’re good at', 'Set your own rate and keep 70%.'],
        ]).filter(Boolean).map(([k, tone, h, l, feat]) => (
          <div key={h} className={classNames(css.hdBenefit, feat ? css.hdBenefitFeat : null)} data-home-benefit={h} data-featured={feat ? 'true' : undefined}>
            <span className={classNames(css.hdBTile, css['hdTone_' + tone])}><DIcon k={k} size={feat ? 30 : 24} /></span>
            <strong>{h}</strong>
            <span>{l}</span>
          </div>
        ))}
      </div>
    </section>
    ) : null}
    {benefits === 'love_it' ? (
    <section className={css.hdBenefitsBand} data-home-love="true" data-benefits-variant="love_it">
      <h2 className={css.hdH2Light}>Why you’ll love it</h2>
      <div className={css.hdBenefits}>
        {[
          ['chats', 'pink', 'One-on-one talking', 'Private chats with a verified adult listener, by text, voice or video.', true],
          ['teach', 'blue', 'One-on-one learning', 'Learn any skill from a Sweet Skillz mentor.', true],
          showFreeNow ? ['gift', 'pink', 'First 15 minutes free', 'Your first session is a Sweet Treat. You only pay for sessions you book after that.'] : null,
          ['chat', 'blue', 'Start now in minutes', 'If a listener is available, start right away. Or book a time that fits you.'],
          ['cal', 'pink', '15-minute sessions', 'Text, voice or video. You choose the format before you book.'],
          ['lock', 'blue', 'Private by design', 'Everyone goes by a display name, and your contact details stay private.'],
          ['people', 'pink', 'Browse free', 'No account needed to look around.'],
          ['headphones', 'blue', 'Listeners keep 70%', 'Listeners set their own rate for text, voice or video.'],
        ].filter(Boolean).map(([k, tone, h, l, feat]) => (
          <div key={h} className={classNames(css.hdBenefit, feat ? css.hdBenefitFeat : null)} data-home-benefit={h} data-featured={feat ? 'true' : undefined}>
            <span className={classNames(css.hdBTile, css['hdTone_' + tone])}><DIcon k={k} size={feat ? 30 : 24} /></span>
            <strong>{h}</strong>
            <span>{l}</span>
          </div>
        ))}
      </div>
    </section>
    ) : null}
    <div className={css.hdPathCards} data-home-paths="true">
      <div className={classNames(css.hdPathCard, css['hdTone_pink'])} data-home-path="listeners">
        <img className={css.hdPathPhoto} src={homeCardListeners} alt="A friendly listener on a call" loading="lazy" data-home-photo="listeners" />
        <span className={css.hdTile}><DIcon k="chats" size={26} /></span>
        <strong className={css.hdCardTitle}>Sweet Listeners</strong>
        <span className={css.hdCardLine}>Someone to talk to about life, feelings, or your day.</span>
        <div className={css.hdPathBtns}>
          <NamedLink name="SearchPage" to={showFreeNow ? { search: '?promoFirstFree=1&availableNow=only' } : { search: theme ? `?availableNow=only&treat=1&topics=${theme.topics.join(',')}` : '?availableNow=only&treat=1' }} className={css.hdPathPrimary} data-home-cta="listeners-primary" onClick={() => onCard('listeners-primary')}>{showFreeNow ? 'Talk free' : 'Let’s talk'}</NamedLink>
          <NamedLink name="AboutPage" className={css.hdPathSecondary} data-home-cta="listeners-learn" onClick={() => onCard('listeners-learn')}>Learn more</NamedLink>
        </div>
      </div>
      <div className={classNames(css.hdPathCard, css['hdTone_blue'])} data-home-path="skillz">
        <img className={css.hdPathPhoto} src={homeCardSkillz} alt="Someone learning a new skill" loading="lazy" data-home-photo="skillz" />
        <span className={css.hdTile}><DIcon k="bookpen" size={26} /></span>
        <strong className={css.hdCardTitle}>Sweet Skillz</strong>
        <span className={css.hdCardLine}>Explore fitness, business, hobbies, and more.</span>
        <div className={css.hdPathBtns}>
          <NamedLink name="SearchPage" to={showFreeNow ? { search: '?promoFirstFree=1&availableNow=only' } : { search: theme ? `?availableNow=only&treat=1&topics=${theme.topics.join(',')}` : '?availableNow=only&treat=1' }} className={css.hdPathPrimary} data-home-cta="skillz-primary" onClick={() => onCard('skillz-primary')}>{showFreeNow ? 'Learn free' : 'Let’s learn'}</NamedLink>
          <NamedLink name="SweetSkillsPage" className={css.hdPathSecondary} data-home-cta="skillz-learn" onClick={() => onCard('skillz-learn')}>Learn more</NamedLink>
        </div>
      </div>
    </div>
    {buyer ? null : (
    <div className={classNames(css.hdPathCards, css.hdEarnCards)} data-home-earn="true">
      <div className={classNames(css.hdPathCard, css['hdTone_pink'])} data-home-path="earn-listen">
        <img className={css.hdPathPhoto} src={homeCardEarnListen} alt="A listener with headphones" loading="lazy" data-home-photo="earn-listen" />
        <span className={css.hdTile}><DIcon k="headphones" size={26} /></span>
        <strong className={css.hdCardTitle}>Become a Listener</strong>
        <span className={css.hdCardLine}>Listen and earn on your schedule.</span>
        <div className={css.hdPathBtns}>
          <NamedLink name="BecomeAListenerPage" className={css.hdPathPrimary} data-home-cta="earn-listen-primary" onClick={() => onCard('earn-listen-primary')}>Get started</NamedLink>
          <NamedLink name="BecomeAListenerPage" className={css.hdPathSecondary} data-home-cta="earn-listen-learn" onClick={() => onCard('earn-listen-learn')}>Learn more</NamedLink>
        </div>
      </div>
      <div className={classNames(css.hdPathCard, css['hdTone_blue'])} data-home-path="earn-teach">
        <img className={css.hdPathPhoto} src={homeCardEarnTeach} alt="A mentor teaching a skill" loading="lazy" data-home-photo="earn-teach" />
        <span className={css.hdTile}><DIcon k="teach" size={26} /></span>
        <strong className={css.hdCardTitle}>Teach a Skill</strong>
        <span className={css.hdCardLine}>Share your expertise.</span>
        <div className={css.hdPathBtns}>
          <NamedLink name="TeachPage" className={css.hdPathPrimary} data-home-cta="earn-teach-primary" onClick={() => onCard('earn-teach-primary')}>Get started</NamedLink>
          <NamedLink name="SweetSkillsPage" className={css.hdPathSecondary} data-home-cta="earn-teach-learn" onClick={() => onCard('earn-teach-learn')}>Learn more</NamedLink>
        </div>
      </div>
    </div>
    )}
    {authed ? null : (
    <div className={css.hdLoginBar} data-home-login="true">
      <span>Already have an account?</span>
      <NamedLink name="LoginPage" className={css.hdLoginBtn} data-home-cta="login" onClick={() => onCard('login')}>Log in</NamedLink>
    </div>
    )}
  </main>
  );
};

export const LandingPageComponent = props => {
  const {
    scrollingDisabled,
    isAuthenticated,
    currentUser,
    currentUserHasListings = false,
    featuredListings = [],
    currentUserOwnListing = null,
    fetchInProgress = false,
    hasFetched = true,
    fetchError = null,
    themeId = null,
  } = props;
  const theme = themeId ? TALK_THEMES[themeId] || null : null;
  const location = useLocation();
  const config = useConfiguration();
  const intl = useIntl();
  const marketplaceName = config.marketplaceName;

  useEffect(() => {
    abandonCheckoutDraft();
  }, []);

  const hiddenIds = useHiddenListingIds();
  const discoveryListings = withoutHidden(
    excludeOwnDiscoveryListings(featuredListings, {
      currentUser,
      currentUserOwnListing,
    }),
    hiddenIds
  );
  const featuredIds = (discoveryListings || []).map(listing => listing?.id?.uuid).filter(Boolean);
  const {
    map: presenceMap,
    pausedMap = {},
    busyMap = {},
    nextAvailableMap = {},
  } = usePresenceMap(featuredIds);
  // Available Now listeners first (stable; keeps existing order within groups).
  const isFeaturedAvailable = listing =>
    resolveListenerAvailability({
      listing,
      online: isListingOnline(listing.id.uuid, presenceMap, listing),
      sessionBusy: !!busyMap[listing.id.uuid],
      startNowPaused: !!pausedMap[listing.id.uuid],
    }).status === LISTENER_STATUS.AVAILABLE;
  const featuredStats = useReviewStats((discoveryListings || []).map(l => l?.id?.uuid).filter(Boolean));
  const pickedFeatured = rankHomeListenerCards(
    pickHomepageListenerCards(filterLandingFeaturedListings(discoveryListings, { presenceMap }), Number.MAX_SAFE_INTEGER).filter(listingHasRealFacePhoto),
    { isAvailable: isFeaturedAvailable, statsMap: featuredStats }
  ).slice(0, HOMEPAGE_LISTENER_PAGE_SIZE);
  const nextSlots = useNextSlots(pickedFeatured.map(l => l.id.uuid));
  const visibleFeatured = pickedFeatured;

  const title = landingSchemaTitle(marketplaceName);
  const description = landingSchemaDescription;

  const showBecomeListener = showBecomeAListenerCta({
    currentUser,
    currentUserHasListings,
    currentUserOwnListing,
    isAuthenticated,
  });
  const dashboardDest = destinationAfterVerifiedAccount(currentUser, { currentUserHasListings });
  // Always keep a listener-card CTA so the card matches the talker card. Guests
  // sign up with listener intent; talker-only opens listening-profile setup.
  // Existing listeners (Listen / Both) get the Listening dashboard — the rest
  // of the site hides “Become a Listener”, so this is the matching next step.
  const listenerCardCta = showBecomeListener
    ? isAuthenticated
      ? { name: 'BecomeAListenerPage', messageId: 'LandingPage.listenCta' }
      : { name: 'BecomeAListenerPage', messageId: 'LandingPage.listenCta' }
    : {
        name: dashboardDest.name,
        to: { search: dashboardDest.search || '?tab=listening' },
        params: dashboardDest.params,
        messageId: 'LandingPage.listenDashboardCta',
      };
  const homeTo = landingPageLinkTo({ isAuthenticated });

  const homeVariantRaw = useHomeVariant(location?.search);
  const homeVariant = theme ? 'd' : homeVariantRaw;
  const paidBuyer = usePaidBuyer(location?.search);
  const showFreeMain = useShowFreeCtas();
  const [returning, setReturning] = React.useState(false);
  React.useEffect(() => {
    if (isAuthenticated) markReturningVisitor();
    setReturning(isReturningVisitor());
  }, [isAuthenticated]);

  if (isAuthenticated && !isPublicHomeView(location?.search)) {
    return (
      <NamedRedirect
        name={dashboardDest.name}
        search={redirectSearchWithPromo(dashboardDest.search, location?.search)}
        params={dashboardDest.params}
      />
    );
  }

  return (
    <Page title={theme ? `${theme.h1} | Sweet Listeners` : title} description={theme ? theme.sub : description} scrollingDisabled={scrollingDisabled}>
      <div className={css.page} data-page="landing">
        {/* New home (Sam mockup, Oct 22 2026 4:25 PM): header, heart, headline, free pill, four path cards. */}
        
        <header className={css.mhHeader} data-home-header={isAuthenticated ? 'member' : 'guest'}>
          <NamedLink name="LandingPage" className={css.mhLogo} aria-label="Sweet Listeners">
            <BrandLockup size="header" />
          </NamedLink>
          <div className={css.mhRight}>
            {isAuthenticated ? (
              <NamedLink name="DashboardPage" className={css.mhSignup} data-home-dashboard="true">Dashboard</NamedLink>
            ) : returning ? (
              <NamedLink name="LoginPage" className={css.mhSignup} data-home-login="true">Log in</NamedLink>
            ) : (
              <NamedLink name="SignupPage" className={css.mhSignup} data-home-signup="true">Create an account</NamedLink>
            )}
            <details className={css.mhMenu}>
              <summary aria-label="Menu" className={css.mhBurger}><span /><span /><span /></summary>
              <nav className={css.mhMenuList}>
                {isAuthenticated ? <NamedLink name="DashboardPage">Dashboard</NamedLink> : <NamedLink name="LoginPage">Log in</NamedLink>}
                {isAuthenticated ? null : <NamedLink name="SignupPage">Create an account</NamedLink>}
                <NamedLink name="SearchPage">Browse</NamedLink>
                <NamedLink name="HowItWorksPage">How it works</NamedLink>
                <NamedLink name="FAQPage">FAQ</NamedLink>
                <NamedLink name="AboutPage">About</NamedLink>
              </nav>
            </details>
          </div>
        </header>

        {homeVariant === 'd' ? <HomeD onCard={card => trackHomeCard(paidBuyer ? 'd_buyer' : 'd', card)} authed={isAuthenticated} returning={returning} buyer={paidBuyer || !!theme} theme={theme} /> : (
        <main className={classNames(css.nhMain, css[`nhV_${homeVariant}`])} data-home-hero="new" data-home-variant={homeVariant}>
          <section className={css.nhHero} data-home-hero-layout={homeVariant}>
            <div className={css.nhHeroText}>
              {homeVariant === 'b' ? (
                <h1 className={css.nhTitle}>Book a private <span className={css.nhAccent}>1-on-1 session</span> in minutes.</h1>
              ) : homeVariant === 'c' ? (
                <h1 className={css.nhTitle}>Book a private 1-on-1 session <span className={css.nhAccent}>in minutes.</span></h1>
              ) : (
                <h1 className={css.nhTitle}>Book a private 1-on-1 session in minutes.</h1>
              )}
              <p className={css.nhSub}>Talk it out, learn a skill, or offer your time — all in one place.</p>
              <div className={css.nhBtns}>
                <NamedLink name="SearchPage" className={css.nhPrimary} data-home-cta="browse" onClick={() => trackHomeCard(homeVariant, 'browse')}>Browse people</NamedLink>
                <NamedLink name="BecomeAListenerPage" className={css.nhSecondary} data-home-cta="offer" onClick={() => trackHomeCard(homeVariant, 'offer')}>Offer sessions</NamedLink>
              </div>
              {showFreeMain ? (
              <NamedLink name="SearchPage" to={{ search: '?promoFirstFree=1&availableNow=only' }} className={css.nhFreeNow} data-home-cta="free-now" onClick={() => trackHomeCard(homeVariant, 'free-now')}>🎁 Use your free session now ›</NamedLink>
              ) : null}
              <p className={css.nhTrustLine}>Text, voice, or video. You choose the person. Sessions aren’t recorded.</p>
              <p className={css.nhSafety}>🔒 Private by design: everyone goes by a display name, and your contact details stay private.</p>
            </div>
            {homeVariant === 'a' ? null : (
              <div className={css.nhHeroArt} aria-hidden="true"><HomePathIcon kind="chat" /></div>
            )}
          </section>
          {visibleFeatured.length ? (
            <section className={css.nhStrip} data-home-strip="true">
              <div className={css.nhStripHead}>
                <h2>{visibleFeatured.some(isFeaturedAvailable) ? 'Available now and popular' : 'Popular people to talk with'}</h2>
                <NamedLink name="SearchPage" className={css.nhSeeAll} data-home-cta="see-all" onClick={() => trackHomeCard(homeVariant, 'see-all')}>See everyone ›</NamedLink>
              </div>
              <div className={css.nhStripRow}>
                {visibleFeatured.slice(0, 8).map(listing => (
                  <Listener
                    key={listing.id.uuid}
                    rich
                    listing={listing}
                    online={isListingOnline(listing.id.uuid, presenceMap, listing)}
                    sessionBusy={!!busyMap[listing.id.uuid]}
                    startNowPaused={!!pausedMap[listing.id.uuid]}
                    nextAvailableAt={nextAvailableMap[listing.id.uuid] || null}
                    nextSlotAt={nextSlots[listing.id.uuid] || null}
                  />
                ))}
              </div>
            </section>
          ) : null}
          {(() => {
            const C = {
              talk: ['SearchPage', null, 'Talk', 'Private sessions to talk through what’s on your mind.', 'chat'],
              learn: ['SweetSkillsPage', null, 'Learn a skill', 'Book a short session with someone who can teach it.', 'cap'],
              listen: ['BecomeAListenerPage', null, 'Listen', 'Earn by being a calm, judgment-free ear. Set your schedule and price.', 'headphones'],
              teach: ['TeachPage', null, 'Teach a skill', 'Share something you know. Set your own price and session length.', 'people'],
            };
            const order = homeVariant === 'b' ? ['talk', 'learn', 'listen', 'teach'] : homeVariant === 'c' ? ['listen', 'teach', 'talk', 'learn'] : ['talk', 'learn', 'listen', 'teach'];
            const big = homeVariant === 'b' ? ['talk', 'learn'] : homeVariant === 'c' ? ['listen', 'teach'] : [];
            return (
              <div className={css.nhCards} data-home-paths="true">
                {order.map(key => {
                  const [name, to, label, line, icon] = C[key];
                  return (
                    <NamedLink key={key} name={name} to={to || undefined} className={classNames(css.nhCard, big.includes(key) ? css.nhCardBig : null)} data-home-card={key} onClick={() => trackHomeCard(homeVariant, key)}>
                      <span className={css.nhIcon} aria-hidden="true"><HomePathIcon kind={icon} /></span>
                      <span className={css.nhCardText}><b>{label}</b><span>{line}</span></span>
                      <span className={css.nhChevron} aria-hidden="true">›</span>
                    </NamedLink>
                  );
                })}
              </div>
            );
          })()}
          <section className={css.nhAbout} data-home-about="true">
            <h2>What We’re All About</h2>
            <p>We make it easy to book a private one-on-one session with someone who gets it. Talk through what’s on your mind, learn something new from someone who knows it, or share your own time by listening or teaching. You pick the person, the format, and the length, and every session stays between the two of you.</p>
            <div className={css.nhAboutLinks}>
              <NamedLink name="HowItWorksPage" className={css.nhSecondary} data-home-learn="how">How it works</NamedLink>
              <NamedLink name="AboutPage" className={css.nhSecondary} data-home-learn="about">About us</NamedLink>
            </div>
          </section>
          {(() => {
            const BL = { chat: ['SearchPage', 'benefit-talk'], cap: ['SweetSkillsPage', 'benefit-learn'], headphones: ['BecomeAListenerPage', 'benefit-earn'] };
            const B = homeVariant === 'b'
              ? [['chat', 'Say it out loud', 'Get the conversation you need, with someone who’s there just for you.'], ['cap', 'Learn it faster', 'Skip the guesswork and learn from someone who’s done it.'], ['headphones', 'Earn on your terms', 'Get paid for your time, on your schedule, at your price.']]
              : homeVariant === 'c'
              ? [['headphones', 'Your time is worth something', 'Get paid to listen or teach. You set the price and the hours.'], ['chat', 'Someone in your corner', 'Have the conversation you need, whenever you need it.'], ['cap', 'Hands-on know-how', 'Learn from someone who’s done it, one session at a time.']]
              : [['chat', 'The conversation you need', 'Talk with someone kind who listens, whenever you need it.'], ['cap', 'Learn from someone who’s done it', 'Book a short session and pick up skills from hands-on experience.'], ['headphones', 'Get paid for your time', 'Listen or teach on your own schedule, at the price you set.']];
            return (
              <div className={classNames(css.nhBenefits, homeVariant === 'b' ? css.nhBenefitsRow : null)} data-home-benefits="true">
                {B.map(([icon, h, l]) => (
                  <NamedLink key={h} name={BL[icon][0]} className={css.nhBenefit} data-home-cta={BL[icon][1]} onClick={() => trackHomeCard(homeVariant, BL[icon][1])}><span className={css.nhIcon} aria-hidden="true"><HomePathIcon kind={icon} /></span><div><h3>{h}</h3><p>{l}</p></div></NamedLink>
                ))}
              </div>
            );
          })()}
          <ul className={css.nhTrust} data-home-trust="true" data-benefits-variant="why_use">
            <li><NamedLink name="FAQPage" data-home-trust-link="safe"><span aria-hidden="true">🛡️</span>Private &amp; Safe</NamedLink></li>
            <li><NamedLink name="AboutPage" data-home-trust-link="community"><span aria-hidden="true">👥</span>Friendly Community</NamedLink></li>
            <li><NamedLink name="HowItWorksPage" data-home-trust-link="judgment"><span aria-hidden="true">🔒</span>No Judgment or Gossip</NamedLink></li>
          </ul>
          <div className={css.nhFinal}>
            <NamedLink name="SignupPage" className={css.nhPrimary} data-home-about-signup="true">Create an account</NamedLink>
          </div>
        </main>
        )}

        <footer className={css.footer}>
          <div className={css.footerTop}>
            {/* Brand shows once, in the header (Sam, Oct 22 2026 5:50 PM). */}
          </div>
          <div className={css.footerLinks}>
            {SITE_FOOTER_LEGAL_LINKS.map(link => (
              <NamedLink key={link.href} name={link.name} to={link.to}>
                {link.label}
              </NamedLink>
            ))}
            <a href="/help" onClick={openHelpWidget} data-footer-help-widget="true">
              Help
            </a>
          </div>
          <EmergencyLine placement="footer" className={css.footerEmergency} />
          <SocialLinks
            links={SITE_SOCIAL_LINKS}
            listClassName={css.footerSocials}
            linkClassName={css.footerSocialLink}
          />
          <p className={css.footerCopyright}>{SITE_FOOTER_COPYRIGHT}</p>
        </footer>
      </div>
    </Page>
  );
};

LandingPageComponent.defaultProps = {
  currentUser: null,
  currentUserHasListings: false,
  currentUserOwnListing: null,
  featuredListings: [],
  fetchInProgress: false,
  hasFetched: true,
  fetchError: null,
};

LandingPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  currentUserHasListings: bool,
  currentUserOwnListing: object,
  isAuthenticated: bool.isRequired,
  featuredListings: arrayOf(object),
  fetchInProgress: bool,
  hasFetched: bool,
  fetchError: object,
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const { currentUser, currentUserOwnListing } = state.user;
  const { featuredListingRefs, fetchInProgress, hasFetched, fetchError } = state.LandingPage || {};
  return {
    currentUser,
    currentUserHasListings: !!state.user?.currentUserHasListings,
    currentUserOwnListing,
    isAuthenticated,
    featuredListings: getListingsById(state, featuredListingRefs || []),
    fetchInProgress: !!fetchInProgress,
    hasFetched: !!hasFetched,
    fetchError: fetchError || null,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
